module.exports = __webpack_public_path__ + "img/icon2.8aa34f62.png";